module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-1.f3f20605.png";